import { action } from 'satcheljs';

export const trialAction = action('trialAction');
